import { useState, useEffect, useCallback } from "react";
import { de } from "../locales/de";
import { en } from "../locales/en";

const LOCALES = { de, en };

// ─────────────────────────────────────────────
// HOOK
// ─────────────────────────────────────────────
export function useTranslation() {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem("habitOS_language");
    if (saved) return saved;
    // Browser-Sprache als Fallback
    const browserLang = navigator.language?.slice(0, 2);
    return browserLang === "de" ? "de" : "en";
  });

  useEffect(() => {
    localStorage.setItem("habitOS_language", lang);
    document.documentElement.setAttribute("lang", lang);
  }, [lang]);

  const toggleLanguage = useCallback(() => {
    setLang(prev => prev === "de" ? "en" : "de");
  }, []);

  // t(key) — übersetzt einen Key
  const t = useCallback((key, vars = {}) => {
    const locale = LOCALES[lang] || LOCALES.de;
    let text = locale[key] || LOCALES.de[key] || key;
    // Variable Substitution: {rate} → wert
    Object.entries(vars).forEach(([k, v]) => {
      text = text.replace(`{${k}}`, String(v));
    });
    return text;
  }, [lang]);

  return { lang, t, toggleLanguage, isDE: lang === "de", isEN: lang === "en" };
}

// ─────────────────────────────────────────────
// SINGLETON für Komponenten außerhalb des Hooks
// ─────────────────────────────────────────────
export function getT() {
  const lang = localStorage.getItem("habitOS_language") || "de";
  const locale = LOCALES[lang] || LOCALES.de;
  return (key, vars = {}) => {
    let text = locale[key] || LOCALES.de[key] || key;
    Object.entries(vars).forEach(([k, v]) => {
      text = text.replace(`{${k}}`, String(v));
    });
    return text;
  };
}
